import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadService } from '../../api/services/file-upload.service';

@Component({
  selector: 'app-preview-image',
  templateUrl: './preview-image.component.html',
  styleUrls: ['./preview-image.component.scss']
})
export class PreviewImageComponent implements OnInit {

  @Input() fileId: string;

  fileUrl: string;

  constructor(public activeModal: NgbActiveModal,
              private fileService: FileUploadService
  ) { }

  ngOnInit() {
    this.fileService.get(this.fileId).subscribe(file => {
      this.fileUrl = file.url;
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/preview-image/preview-image.component.ts